import { mapGetters, mapMutations } from "vuex";

// components
const thanks = () => import("@/components/popups/thanks/index.vue");
const restorePasswordEmail = () =>
    import("@/components/popups/restore-password-email/index.vue");
const setNewPassword = () => import("@/components/popups/set-new-password/index.vue");
const videoTrailer = () => import("@/components/popups/video-trailer/index.vue");
const cancelTestPopup = () => import("@/components/popups/cancel-test/index.vue");
const cancelSubscriptionPopup = () =>
    import("@/components/popups/cancel-subscription/index.vue");
const updateSubscriptionPopup = () =>
    import("@/components/popups/update-subscription/index.vue");
const deleteCardPopup = () => import("@/components/popups/delete-card/index.vue");

export default {
    name: "hidden",
    components: {
        thanks,
        restorePasswordEmail,
        setNewPassword,
        videoTrailer,
        cancelTestPopup,
        cancelSubscriptionPopup,
        updateSubscriptionPopup,
        deleteCardPopup,
    },
    computed: {
        ...mapGetters({
            showRestorePassword: "auth/showRestorePassword",
            showSetNewPassword: "auth/showSetNewPassword",
            popupTrailer: "popups/popupTrailer",
            showPopupCancelTest: "tests/showPopupCancel",
            showPopupCancelSubscription: "userPaymentsHistory/showPopupCancel",
            showPopupUpdateSubscription: "userPaymentsHistory/showPopupUpdate",
            showPopupDeleteCard: "userPayments/showPopupDelete",
        }),
    },
    methods: {
        ...mapMutations({
            changePopupRestorePasswordEmail: `auth/AUTH_SHOW_POPUP_RESTORE_PASSWORD`,
            changePopupNewPassword: `auth/AUTH_SHOW_POPUP_NEW_PASSWORD`,
            changePopupTrailer: `popups/CHANGE_POPUP_TRAILER`,
            changeShowPopupCancelTest: "tests/CHANGE_POPUP_CANCEL_TEST",
            changeShowPopupCancelSubscription:
                "userPaymentsHistory/CHANGE_POPUP_CANCEL_SUBSCRIPTION",
            changeShowPopupUpdateSubscription:
                "userPaymentsHistory/CHANGE_POPUP_UPDATE_SUBSCRIPTION",
            changeShowPopupDeleteCard: "userPayments/CHANGE_POPUP_DELETE_CARD",
        }),
    },
};
